export class Product {
    public Id: number;
    public RequestNumber: number;
    public RequestRaisedBy = '';
    public ProjectCategory = '';
    public ProjectName = '';
    public ProjectAddress = '';
    public ProjectStatus = false;
    public ContactStatus = '';
    public FinalPlat = '';
    public LotId: number;
    public mainInstallationStatus: number;
    public developmentstatus = '';
}
